import { countryData } from '~/shared/constants/countryData.const'

import { Order } from './order'

export enum CheckoutScenario {
  TUTOR_FOR_SELF = 'tutor-for-self',
  TUTOR_FOR_OTHER = 'tutor-for-other',
  VIDEO_CHAT = 'video-chat',
  SUBSCRIPTION = 'subscription',
}

export enum BookingScenario {
  TUTORING = 'tutoring',
  VIDEO_CHAT = 'video-chat',
}

export enum BookingFor {
  SELF = 'self',
  OTHER = 'other',
}

export enum BookingForGroup {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export enum BookingLanguage {
  ENGLISH = 'english',
  NORWEGIAN = 'norwegian',
  AFRIKAANS = 'afrikaans',
  DUTCH = 'dutch',
  FILIPINO = 'filipino',
  HINDI = 'hindi',
  SPANISH = 'spanish',
  URDU = 'urdu',
}

export enum TutorLevel {
  TUTOR = 'mentor',
  SENIOR = 'seniorMentor',
}

export enum TutorPackage {
  HOURS_1 = 'hours_1',
  HOURS_4 = 'hours_4',
  HOURS_8 = 'hours_8',
  HOURS_6 = 'hours_6',
  HOURS_16 = 'hours_16',
  HOURS_32 = 'hours_32',
  HOURS_40 = 'hours_40',
  HOURS_64 = 'hours_64',
  HOURS_80 = 'hours_80',
  MINUTES_15 = 'minutes_15',
}

export interface PaymentInfo {
  amount: number
  created: number
  currency: string
  order: Order | undefined
}

export enum BookingCurrency {
  USD = 'usd',
  AED = 'aed',
  AFN = 'afn',
  ALL = 'all',
  AMD = 'amd',
  ANG = 'ang',
  AOA = 'aoa',
  ARS = 'ars',
  AUD = 'aud',
  AWG = 'awg',
  AZN = 'azn',
  BAM = 'bam',
  BBD = 'bbd',
  BDT = 'bdt',
  BGN = 'bgn',
  BHD = 'bhd',
  BIF = 'bif',
  BMD = 'bmd',
  BND = 'bnd',
  BOB = 'bob',
  BRL = 'brl',
  BSD = 'bsd',
  BWP = 'bwp',
  BYN = 'byn',
  BZD = 'bzd',
  CAD = 'cad',
  CDF = 'cdf',
  CHF = 'chf',
  CLP = 'clp',
  CNY = 'cny',
  COP = 'cop',
  CRC = 'crc',
  CVE = 'cve',
  CZK = 'czk',
  DJF = 'djf',
  DKK = 'dkk',
  DOP = 'dop',
  DZD = 'dzd',
  EGP = 'egp',
  ETB = 'etb',
  EUR = 'eur',
  FJD = 'fjd',
  FKP = 'fkp',
  GBP = 'gbp',
  GEL = 'gel',
  GIP = 'gip',
  GMD = 'gmd',
  GNF = 'gnf',
  GTQ = 'gtq',
  GYD = 'gyd',
  HKD = 'hkd',
  HNL = 'hnl',
  HTG = 'htg',
  HUF = 'huf',
  IDR = 'idr',
  ILS = 'ils',
  INR = 'inr',
  ISK = 'isk',
  JMD = 'jmd',
  JOD = 'jod',
  JPY = 'jpy',
  KES = 'kes',
  KGS = 'kgs',
  KHR = 'khr',
  KMF = 'kmf',
  KRW = 'krw',
  KWD = 'kwd',
  KYD = 'kyd',
  KZT = 'kzt',
  LAK = 'lak',
  LBP = 'lbp',
  LKR = 'lkr',
  LRD = 'lrd',
  LSL = 'lsl',
  MAD = 'mad',
  MDL = 'mdl',
  MGA = 'mga',
  MKD = 'mkd',
  MMK = 'mmk',
  MNT = 'mnt',
  MOP = 'mop',
  MRO = 'mro',
  MUR = 'mur',
  MVR = 'mvr',
  MWK = 'mwk',
  MXN = 'mxn',
  MYR = 'myr',
  MZN = 'mzn',
  NAD = 'nad',
  NGN = 'ngn',
  NIO = 'nio',
  NOK = 'nok',
  NPR = 'npr',
  NZD = 'nzd',
  OMR = 'omr',
  PAB = 'pab',
  PEN = 'pen',
  PGK = 'pgk',
  PHP = 'php',
  PKR = 'pkr',
  PLN = 'pln',
  PYG = 'pyg',
  QAR = 'qar',
  RON = 'ron',
  RSD = 'rsd',
  RUB = 'rub',
  RWF = 'rwf',
  SAR = 'sar',
  SBD = 'sbd',
  SCR = 'scr',
  SEK = 'sek',
  SGD = 'sgd',
  SHP = 'shp',
  SLE = 'sle',
  SOS = 'sos',
  SRD = 'srd',
  STD = 'std',
  SZL = 'szl',
  THB = 'thb',
  TJS = 'tjs',
  TND = 'tnd',
  TOP = 'top',
  TRY = 'try',
  TTD = 'ttd',
  TWD = 'twd',
  TZS = 'tzs',
  UAH = 'uah',
  UGX = 'ugx',
  UYU = 'uyu',
  UZS = 'uzs',
  VND = 'vnd',
  VUV = 'vuv',
  WST = 'wst',
  XAF = 'xaf',
  XCD = 'xcd',
  XOF = 'xof',
  XPF = 'xpf',
  YER = 'yer',
  ZAR = 'zar',
  ZMW = 'zmw',
}

export enum SchoolSystem {
  NORWEGIAN = 'norwegian',
  INTERNATIONAL = 'international',
}

export enum LevelOfEducation {
  GRADE_0_TO_4 = 'grade-0-to-4',
  GRADE_5_TO_7 = 'grade-5-to-7',
  GRADE_8_TO_10 = 'grade-8-to-10',
  GRADE_11_TO_13 = 'grade-11-to-13',
  UNIVERSITY_OR_COLLEGE = 'university-or-college',
}

export enum Subject {
  GENERAL_HOMEWORK_HELP = 'general-homework-help',
  MATH = 'math',
  BIOLOGY = 'biology',
  CHEMISTRY = 'chemistry',
  ECONOMICS = 'economics',
  FINANCE = 'finance',
  PHYSICS = 'physics',
  STATISTICS = 'statistics',
  OTHER = 'other',
}

export enum GradeLevel {
  NO_1P = '1P',
  NO_1T = '1T',
  NO_2P = '2P',
  NO_2P_Y = '2P_Y',
  NO_IB = 'NO_IB',
  NO_R1 = 'R1',
  NO_R2 = 'R2',
  NO_S1 = 'S1',
  NO_S2 = 'S2',
  NO_SUPPLEMENTARY = 'NO_SUPPLEMENTARY',
}

export interface SubjectItem {
  name: Subject
  gradeLevels?: GradeLevel[]
}

export interface Subjects {
  levelsOfEducation: LevelOfEducation[]
  schoolSystem?: SchoolSystem | null
  schoolCountry?: (typeof countryData)[number] | null
  subjects: SubjectItem[]
}

export enum PreferredDay {
  ANY = 'anyDay',
  MON = 'monday',
  TUE = 'tuesday',
  WED = 'wednesday',
  THU = 'thursday',
  FRI = 'friday',
  SAT = 'saturday',
  SUN = 'sunday',
}

export enum PreferredTimeslot {
  FROM_8_TO_9 = '8-9',
  FROM_9_TO_10 = '9-10',
  FROM_10_TO_11 = '10-11',
  FROM_11_TO_12 = '11-12',
  FROM_12_TO_13 = '12-13',
  FROM_13_TO_14 = '13-14',
  FROM_14_TO_15 = '14-15',
  FROM_15_TO_16 = '15-16',
  FROM_16_TO_17 = '16-17',
  FROM_17_TO_18 = '17-18',
  FROM_18_TO_19 = '18-19',
  FROM_19_TO_20 = '19-20',
  FROM_20_TO_21 = '20-21',
  FROM_21_TO_22 = '21-22',
}

export interface PreferredTime {
  day: PreferredDay
  startHour: number
  endHour: number
}

export interface TimeslotNew {
  startTime: string
  endTime: string
}

export interface Timeslot {
  weekday: PreferredDay
  startTime: number
  endTime: number
}

export enum City {
  ONLINE = 'online',
  BERGEN = 'bergen',
  OSLO = 'oslo',
  STAVANGER = 'stavanger',
  TRONDHEIM = 'trondheim',
  KRISTIANSAND = 'kristiansand',
}

export enum EducationalDegree {
  ASSOCIATE_DEGREE = 'associate',
  BACHELORS_DEGREE = 'bachelor',
  MASTERS_DEGREE = 'master',
  DOCTORAL_DEGREE = 'doctoral',
  RISING_STAR = 'risingStar',
}

export enum Location {
  ONLINE = 'online',
  BERGEN = 'bergen',
  OSLO = 'oslo',
  STAVANGER = 'stavanger',
  TRONDHEIM = 'trondheim',
  KRISTIANSAND = 'kristiansand',
}

export enum Trait {
  ENTHUSIASTIC = 'enthusiastic',
  PATIENT = 'patient',
  CREATIVE = 'creative',
  SPORTY = 'sporty',
  AMBITIOUS = 'ambitious',
  STRICT = 'strict',
  ADAPTIVE = 'adaptive',
  DIRECT = 'direct',
  EMPHATIC = 'emphatic',
  CALM = 'calm',
  ENERGETIC = 'energetic',
  LEADERSHIP = 'leadership',
  ORIGINAL = 'original',
  PLAYFUL = 'playful',
  ACADEMIC = 'academic',
  TOLERANT = 'tolerant',
  WITTY = 'witty',
  OPTIMISTIC = 'optimistic',
  CHEERFUL = 'cheerful',
  DETERMINED = 'determined',
}

export interface AvailableVideoChatTimeSlots {
  startMinute: number
  endMinute: number
  languages: BookingLanguage[]
  mentorId: number
  scheduleId: number
  booked: boolean
}
